import React, { Component } from "react";
import CartContext from "./CartContext";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { LoadSpinner } from "./LoadSpinner";
import { Country, State, City } from "country-state-city";
import Swal from "sweetalert2";

import {
  Container,
  Row,
  Col,
  Nav,
  Form,
  Button,
  Modal,
  FloatingLabel,
  Alert,
  ModalBody,
} from "react-bootstrap";

export default class UserLogin extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      signin: true,
      reload: false,
    };
  }

  LoginValid = () => {
    this.props.onHide();
  };
  componentDidMount() {}

  render() {
    return (
      <>
        <Helmet>
          <link href="dist/css/bootstrap.min.css" rel="stylesheet" />
          <link href="dist/css/style.css" rel="stylesheet" />
          <link href="dist/css/responsive.css" rel="stylesheet" />
          <link href="dist/css/font-awesome.min.css" rel="stylesheet" />
          <script src="dist/js/custom.js"></script>
        </Helmet>
        <div className="Container-fluid mx-0 px-1 ">
          <Modal
            {...this.props}
            aria-labelledby="contained-modal-title-vcenter"
            size={this.state.signin == true ? "" : "lg"}
            centered
            className=" usedLoginDsn"
          >
            <Modal.Header className="border" closeButton>
              <Modal.Title
                className="text-primary"
                // style={{ color: "gray" }}
              >
                {this.state.signin == true ? (
                  <>Login & OTP verification</>
                ) : (
                  <>SignUp & OTP verification</>
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
              <div className="row mt-0 mx-1 px-0 ">
                <div className="col-md-12 py-3">
                  <Row>
                    <Col>
                      {this.state.reload == false ? (
                        <>
                          <Login
                            LoginValid={this.LoginValid}
                            loginmethod={
                              this.state.signin == true ? "SignIn" : "SignUp"
                            }
                          ></Login>
                        </>
                      ) : (
                        <></>
                      )}

                      {this.state.signin == true ? (
                        <>
                          <h5 className="text-center mb-5 ">
                            Are you first time here? Please
                            <Button
                              className="border-0"
                              style={{
                                backgroundColor: "white",
                                color: "blue",
                              }}
                              onClick={(e) => {
                                this.setState({ signin: false }, () => {
                                  this.setState({ reload: true }, () => {
                                    this.setState({ reload: false });
                                  });
                                });
                              }}
                            >
                              <u>Signup !</u>
                            </Button>
                          </h5>
                        </>
                      ) : (
                        <>
                          <h5 className="text-center mb-5 ">
                            Already an Existing User?{" "}
                            <Button
                              className="border-0"
                              style={{
                                backgroundColor: "white",
                                color: "blue",
                              }}
                              onClick={(e) => {
                                this.setState({ signin: true }, () => {
                                  this.setState({ reload: true }, () => {
                                    this.setState({ reload: false });
                                  });
                                });
                              }}
                            >
                              <u>Login</u>
                            </Button>
                          </h5>
                        </>
                      )}
                    </Col>
                  </Row>
                  <div className="justify-content-center text-secondary border-0 text-center py-1">
                    <Row className="text-center text-black">
                      <Col>By continuing, you agree to our </Col>
                    </Row>
                    <Row>
                      <Nav className="justify-content-center text-secondary border-0 my-2">
                        <Nav.Link
                          as={Link}
                          to="/TermsAndConditions"
                          className=""
                          target="_blank"
                        >
                          <u>Terms & Conditions</u>
                        </Nav.Link>
                        <span className="mx-1">|</span>
                        <Nav.Link
                          as={Link}
                          to="/PrivacyPolicy"
                          target="_blank"
                          className=""
                        >
                          <u>Privacy Policy</u>
                        </Nav.Link>
                        {/* <a
                          className=""
                          href="https://ecprdstorage01.blob.core.windows.net/elasticcart/Terms of Service.pdf"
                          target="_blank"
                          style={{
                            backgroundColor: "white",
                            color: "green",
                          }}
                        >
                          Terms & Conditions
                        </a>
                        <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>                        
                        <a
                          className=""
                          href="https://ecprdstorage01.blob.core.windows.net/elasticcart/Privacy Policy.pdf"
                          target="_blank"
                          style={{
                            backgroundColor: "white",
                            color: "green",
                          }}
                        >
                          Privacy Policy
                        </a> */}
                      </Nav>
                    </Row>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </>
    );
  }
}

class Login extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      businessName: "",
      businessType: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pinCode: "",
      contactNo: "",
      emailId: "",
      otpsent: "",
      otpentered: "",
      otpValidationSuccess: false,
      isValidLogin: "false",
      ValidationStatus: "",
      otpValidationStatus: "",
      loginResultText: "",
      userData: null,
      showTermsAndConditions: false,
    };
  }

  handleChangeeMobileNo = (event) => {
    this.setState({ contactNo: event.target.value });
    this.setState({ ValidationStatus: "" });
    this.setState({ otpValidationStatus: "" });
    this.setState({ otpValidationSuccess: false });
    this.setState({ otpsent: false });
    this.setState({ otpentered: "" });
  };

  handleEmailIdChange = (event) => {
    this.setState({ emailId: event.target.value });
    this.setState({ ValidationStatus: "" });
    this.setState({ otpValidationStatus: "" });
    this.setState({ otpValidationSuccess: false });
    this.setState({ otpsent: false });
    this.setState({ otpentered: "" });
    this.setState({ loginResultText: "" });
  };

  handleChangeOtp = (event) => {
    this.setState({ otpentered: event.target.value });
    this.setState({ ValidationStatus: "" });
    this.setState({ otpValidationStatus: "" });
    this.setState({ otpValidationSuccess: false });
  };

  validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  SendEmailOtp = (resend) => {
    this.setState({ otpentered: "" });
    if (this.state.emailId.length == "") {
      this.setState({
        ValidationStatus: "Invalid Email ID! Please try again!",
      });
      return;
    }
    var emailvalid = this.validateEmail(this.state.emailId);
    if (emailvalid == false) {
      this.setState({
        ValidationStatus: "Invalid Email ID! Please try again!",
      });
      return;
    }

    var otpValue = Math.floor(1000 + Math.random() * 9000);

    if (this.context.GetEcSettingValueByName("liveMode") == "false") {
      this.setState({ otpentered: otpValue });
      this.setState({ otpsent: otpValue });
    } else {
      this.setState({ otpsent: otpValue });
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      };

      fetch(
        process.env.REACT_APP_API +
          "Consumers/SendEmailOtp/" +
          this.context.storeId +
          "," +
          this.state.emailId +
          "," +
          otpValue,
        requestOptions
      )
        .then((response) => {
          if (response.status === 200) {
            var ctrl = document.getElementById("OTP");
            if (ctrl) ctrl.focus();
            this.setState(
              {
                ValidationStatus:
                  "OTP has been sent to your Email Account. \r Check your Inbox or Junk/Spam folders!  ",
              },
              () => {}
            );
            if (resend == true) {
              alert("We have resent OTP! Please check!");
            }
          } else {
            this.setState({
              ValidationStatus: "We Unable to send OTP. Please try later!",
            });
          }
        })
        .catch((error) => {
          console.error("There was an error! ", error);
          alert("err SendSmsOtp:" + error);
        });
    }
  };

  SendSmsOtp = (resend) => {
    this.setState({ otpentered: "" });
    if (this.state.contactNo.length != 10) {
      this.setState({
        ValidationStatus: "Invalid Phone Number! Please try again!",
      });
      return;
    }

    var otpValue = Math.floor(1000 + Math.random() * 9000);

    if (this.context.GetEcSettingValueByName("liveMode") == "false") {
      this.setState({ otpentered: otpValue });
      this.setState({ otpsent: otpValue });
    } else {
      this.setState({ otpsent: otpValue });
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      };

      fetch(
        process.env.REACT_APP_API +
          "Consumers/SendAgaramSMS/" +
          "Customer" +
          "," +
          this.state.contactNo +
          "," +
          otpValue,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status == 404 || data.status == 400) {
            this.setState({
              ValidationStatus: "We Unable to send OTP. Please try later!",
            });
            return;
          }
          var ctrl = document.getElementById("OTP");
          if (ctrl) ctrl.focus();
          this.setState({
            ValidationStatus:
              "Please check!  OTP has been sent to you Phone Number.",
          });
          if (resend == true) {
            alert("We have resent OTP! Please check!");
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
          alert("err:" + error);
        });
    }
  };

  ValidateOtp = () => {
    if (this.state.otpsent == this.state.otpentered) {
      if (this.props.loginmethod == "SignIn") {
        this.ValidateLogin();
      } else {
        this.SignUp();
      }
    } else {
      this.setState({
        otpValidationStatus: "Invalid OTP. Please enter valid OTP!",
      });
    }
  };

  ValidateLogin = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "Sales/LoginTenant/" +
        (this.state.contactNo == "" ? "none" : this.state.contactNo) +
        "/" +
        (this.state.emailId == "" ? "none" : this.state.emailId),
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404) {
          this.setState({
            loginResultText:
              "Email Id does not exist! Please Signup if you're first time user.",
          });
          return;
        } else if (data.status == 400) {
          this.setState({
            loginResultText: "Unable to Signup! Pleae try later.",
          });
        }
        // data = JSON.parse(data);
        this.setState({ otpValidationSuccess: true });
        this.setState({ isValidLogin: true });
        this.setState({ userData: data });
        this.context.storeUserData(data);
        this.context.RefreshBearerTokenWithMobileNoOrEmailId(data);
        this.props.LoginValid();
        Swal.fire({
          text: "Welcome back! " + data.firstName + " " + data.lastName,
          // text: "Welcome back " + data.firstName + "!",
          confirmButtonColor: "#23b14d",
          // confirmButtonText: "Ok",
          timer: 1000,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      })
      .catch((error) => {
        console.error("There was an error!", error);
        alert("err:" + error);
      });
  };

  SignUp = () => {
    var userData = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      contactNo: this.state.contactNo,
      emailId: this.state.emailId,
      address: this.state.address,
      state: this.state.state,
      country: this.state.country,
      pinCode: this.state.pinCode,
      city: this.state.city,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    };

    fetch(
      process.env.REACT_APP_API +
        "Sales/SignUp/" +
        (this.state.contactNo == "" ? "none" : this.state.contactNo) +
        "/" +
        (this.state.emailId == "" ? "none" : this.state.emailId),
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404) {
          this.setState({
            loginResultText:
              "This Email Id already exist. Please try to Login! ",
          });
          return;
        } else if (data.status == 400) {
          this.setState({
            loginResultText: "Unable to Signup! Pleae try later.",
          });
          return;
        }
        // data = JSON.parse(data);
        this.setState({ otpValidationSuccess: true });
        this.setState({ userData: data });
        this.context.storeUserData(data);
        this.context.RefreshBearerTokenWithMobileNoOrEmailId(data);
        this.props.LoginValid();
        Swal.fire({
          title: "Status",
          // confirmButtonColor: "#23B14D",
          // cancelButtonColor: "#dbdbdb",
          text: "Signed up successfully!",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      })
      .catch((error) => {
        console.error("There was an error!", error);
        alert("err:" + error);
      });
  };

  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      this.setState({ validated: true });
    }
  };
  componentDidMount() {
    this.setState({ loginResultText: "" });
  }
  componentDidUpdate() {}

  ShowTermsAndConditionsClick = () => {
    this.setState({ showTermsAndConditions: true });
  };
  HideTermsAndConditions = () => {
    this.setState({ showTermsAndConditions: false });
  };

  ShowPrivacyPolicyClick = () => {
    this.setState({ showPrivacyPolicy: true });
  };
  HidePrivacyPolicy = () => {
    this.setState({ showPrivacyPolicy: false });
  };

  render() {
    return (
      <>
        <div className="mx-0 px-1 p-2 text-dark ">
          <Form
            noValidate
            validated={this.state.validated}
            onSubmit={this.handleSubmit}
          >
            {this.context.GetEcSettingValueByName("loginMethod") == "EMAIL" ? (
              <>
                {this.props.loginmethod == "SignIn" ? (
                  <>
                    <div className="text-start">Enter your Email ID :</div>
                    <Form.Control
                      size="lg"
                      type="email"
                      placeholder="Enter your Email ID "
                      className="text-center p-3 w-100 m-0 fw-bold loginDsn signupmobilenoandotp"
                      value={this.state.emailId}
                      required
                      autoComplete="off"
                      onChange={this.handleEmailIdChange}
                    />
                  </>
                ) : (
                  <>
                    <Row>
                      <Col>
                        <Form.Group controlId="validationCustom01">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="First Name *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="text"
                              name="firstName"
                              placeholder="First Name *"
                              className="bg-white"
                              size="lg"
                              required
                              value={this.state.firstName}
                              onChange={(e) =>
                                this.setState({
                                  firstName: e.target.value,
                                })
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter your First Name
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="validationCustom01">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Last Name *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="text"
                              name="firstName"
                              placeholder="Last Name *"
                              className="bg-white"
                              size="lg"
                              required
                              value={this.state.lastName}
                              onChange={(e) =>
                                this.setState({
                                  lastName: e.target.value,
                                })
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter Last Name
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group controlId="validationCustom04">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Email ID *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="email"
                              name="emailId"
                              placeholder="Email ID *"
                              required
                              className="bg-white"
                              size="lg"
                              value={this.state.emailId}
                              onChange={(e) =>
                                this.setState({ emailId: e.target.value })
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Email ID.
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="validationCustom03">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Mobile Number *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="text"
                              name="contactNo"
                              placeholder="Contact Number *"
                              className="bg-white"
                              size="lg"
                              required
                              value={this.state.contactNo}
                              onChange={(e) =>
                                this.setState({
                                  contactNo: e.target.value,
                                })
                              }
                            />

                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Phone Number!
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col>
                        <Form.Group controlId="validationCustom01">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Business Name *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="text"
                              name="businessName"
                              placeholder="Business Name *"
                              className="bg-white"
                              size="lg"
                              required
                              value={this.state.businessName}
                              onChange={(e) =>
                                this.setState({
                                  businessName: e.target.value,
                                })
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter your Business Name
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="validationCustom01">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Business Type *"
                            className="mb-3  "
                          >
                            <Form.Select
                              type="text"
                              name="businessType"
                              className="bg-white"
                              required
                              value={this.state.businessType}
                              onChange={(e) =>
                                this.setState({
                                  businessType: e.target.value,
                                })
                              }
                            >
                              <option value=""></option>
                              <option value="Retail/Wholesale">
                                Retail/Wholesale
                              </option>
                              <option value="Reaturant">Reaturant </option>
                              <option value="Manufacturer">
                                Manufacturer{" "}
                              </option>
                              <option value="Product Servicing">
                                Product Servicing{" "}
                              </option>
                              <option value="Logistics">Logistics </option>
                              <option value="Software">Software </option>
                              <option value="Banking/Accounting">
                                Banking/Accounting{" "}
                              </option>
                              <option value="Auditing">Auditing </option>
                              <option value="Trading">Trading </option>
                              <option value="Automotive">Automotive </option>
                              <option value="Others">Others </option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              Please enter your Business Type
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col sm={8}>
                        <Form.Group controlId="validationCustom07">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Full Address *"
                            className="mb-3 moveLabelUp "
                          >
                            <Form.Control
                              type="text"
                              name="address"
                              size="lg"
                              required
                              placeholder="Full Address *"
                              value={this.state.address}
                              onChange={(e) =>
                                this.setState({ address: e.target.value })
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter address
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col sm={4}>
                        <Form.Group controlId="validationCustom07">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="City *"
                            className="mb-3 moveLabelUp "
                          >
                            <Form.Control
                              type="text"
                              name="city"
                              size="lg"
                              required
                              placeholder="City *"
                              value={this.state.city}
                              onChange={(e) =>
                                this.setState({ city: e.target.value })
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter City
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group controlId="validationCustom09">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Country *"
                            className="mb-3  "
                          >
                            <Form.Select
                              value={this.state.country}
                              name="country"
                              required
                              placeholder="Select Your Country *"
                              onChange={(e) =>
                                this.setState({ country: e.target.value })
                              }
                            >
                              <option value=""></option>
                              {Country.getAllCountries().map((country) => (
                                <>
                                  <option value={country.isoCode}>
                                    {country.name}
                                  </option>
                                </>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              Please select country
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="validationCustom10">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="State *"
                            className="mb-3  "
                          >
                            <Form.Select
                              value={this.state.state}
                              name="state"
                              required
                              onChange={(e) =>
                                this.setState({ state: e.target.value })
                              }
                            >
                              <option value=""></option>
                              {State.getStatesOfCountry(this.state.country).map(
                                (s1) => (
                                  <>
                                    <option>{s1.name}</option>
                                  </>
                                )
                              )}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              Please select State
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="validationCustom07">
                          <FloatingLabel
                            controlId="floatingInput"
                            label="PinCode *"
                            className="mb-3 moveLabelUp "
                          >
                            <Form.Control
                              type="text"
                              name="pinCode"
                              size="lg"
                              required
                              placeholder="PinCode *"
                              value={this.state.pinCode}
                              onChange={(e) =>
                                this.setState({ pinCode: e.target.value })
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter PinCode
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
            {this.context.GetEcSettingValueByName("loginMethod") == "SMS" ? (
              <>
                {this.props.loginmethod == "SignIn" ? (
                  <>
                    <Col xs={1}></Col>
                    <Col xs={2} className="m-0 p-0">
                      <Form.Control
                        size="lg"
                        type="text"
                        placeholder={"+" + "91"}
                        className={"text-center p-3 w-100 m-0 bg-white"}
                        value={"+" + "91"}
                        disabled
                      />
                    </Col>
                    <Col xs={8} className="m-0 p-0">
                      <Form.Control
                        size="lg"
                        type="text"
                        placeholder="Enter your Mobile Number "
                        className={"text-center p-3 w-100 m-0 fw-bold bg-white"}
                        value={this.state.contactNo}
                        maxLength={10}
                        required
                        autoComplete="off"
                        onChange={this.handleChangeeMobileNo}
                      />
                    </Col>
                    <Col xs={1}></Col>
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}

            <div className="text-center text-primary">
              <br></br>
              <h5 className="blink_me text-primary">
                {this.state.ValidationStatus}
              </h5>
            </div>

            <div className="text-center text-primary">
              <h5 className="blink_me text-center text-primary">
                {this.state.loginResultText}
              </h5>
            </div>

            {this.state.otpsent == "" ? (
              <>
                <div className="text-center py-1">
                  <Button
                    type="submit"
                    className={window.innerWidth > 1200 ? "w-50" : "w-100"}
                    onClick={(e) =>
                      this.context.GetEcSettingValueByName("loginMethod") ==
                      "SMS"
                        ? this.SendSmsOtp(false)
                        : this.SendEmailOtp(false)
                    }
                  >
                    <b>Send Email OTP </b>
                  </Button>
                </div>
              </>
            ) : (
              ""
            )}

            {this.state.otpsent != "" ? (
              <>
                <div className="otpDsn">
                  <Row>
                    <br />
                  </Row>
                  <Row>
                    <Col xs={7}>
                      <label>Enter OTP</label>
                      <Form.Control
                        size="lg"
                        type="text"
                        maxLength={6}
                        id="OTP"
                        placeholder=""
                        value={this.state.otpentered}
                        className="text-center signupmobilenoandotp"
                        onChange={this.handleChangeOtp}
                      />
                      <h5 className="blink_me">
                        {this.state.otpValidationStatus}
                      </h5>
                    </Col>
                    <Col xs={5}>
                      <Button
                        variant="primary"
                        type="submit"
                        style={{
                          marginTop: "20px",
                        }}
                        size="lg"
                        onClick={this.ValidateOtp}
                      >
                        <b>Proceed </b>
                      </Button>
                    </Col>
                  </Row>
                </div>

                {/* Login Submit */}

                <br></br>
                <div className="text-center">
                  <Button
                    className=" mx-1 bg-white text-black border-0"
                    onClick={(e) =>
                      this.context.GetEcSettingValueByName("loginMethod") ==
                      "SMS"
                        ? this.SendSmsOtp(true)
                        : this.SendEmailOtp(true)
                    }
                  >
                    <h6 className="mb-3 text-black">
                      Did not receive OTP?{" "}
                      <span
                        style={{
                          backgroundColor: "white",
                          color: "blue",
                        }}
                      >
                        <u>Resend OTP</u>
                      </span>
                    </h6>
                  </Button>
                </div>
              </>
            ) : (
              ""
            )}
          </Form>
        </div>
        {this.state.showTermsAndConditions == true ? (
          <TermsAndConditionsModalView
            OnHide={this.HideTermsAndConditions}
          ></TermsAndConditionsModalView>
        ) : (
          ""
        )}
        {this.state.showPrivacyPolicy == true ? (
          <PrivacyPolicyModalView
            OnHide={this.HidePrivacyPolicy}
          ></PrivacyPolicyModalView>
        ) : (
          ""
        )}
      </>
    );
  }
}

export class TermsAndConditionsModalView extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = { loadSpinnerOpen: false };
  }
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  getTermsAndConditions = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Consumers/GetTermsAndConditionsHtml/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
          this.HideLoadSpinner();
        } else {
          var d1 = document.getElementById("one");
          if (d1) {
            d1.innerHTML = data;
          }
          this.HideLoadSpinner();
        }
      })
      .catch((error) => {
        console.error("getTermsAndConditions!", error);
        this.HideLoadSpinner();
      });
  };
  handleClose = () => {
    this.props.OnHide();
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getTermsAndConditions();
  }
  render() {
    return (
      <div className="container">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={true}
          onHide={this.handleClose}
          dialogClassName="ProductModal"
        >
          <Modal.Header closeButton className="bg-white border">
            <Modal.Title id="contained-modal-title-vcenter">
              Terms and Conditions
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid ">
            {this.state.loadSpinnerOpen === true ? (
              <LoadSpinner open="true"></LoadSpinner>
            ) : (
              ""
            )}
            <h5>
              <div id="one"></div>
            </h5>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
export class PrivacyPolicyModalView extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = { loadSpinnerOpen: false };
  }
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  getPrivacyPolicy = () => {
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "Consumers/GetPrivacyPolicyHtml/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
          this.HideLoadSpinner();
        } else {
          var d1 = document.getElementById("one");
          if (d1) {
            d1.innerHTML = data;
          }
          this.HideLoadSpinner();
        }
      })
      .catch((error) => {
        console.error("getPrivacyPolicy!", error);
        this.HideLoadSpinner();
      });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getPrivacyPolicy();
  }

  handleClose = () => {
    this.props.OnHide();
  };

  render() {
    return (
      <div className="container">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={true}
          onHide={this.handleClose}
          dialogClassName="ProductModal"
        >
          <Modal.Header closeButton className="bg-white border">
            <Modal.Title id="contained-modal-title-vcenter">
              Privacy Policy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid ">
            {this.state.loadSpinnerOpen === true ? (
              <LoadSpinner open="true"></LoadSpinner>
            ) : (
              ""
            )}
            <h5>
              <div id="one"></div>
            </h5>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
